import { render, staticRenderFns } from "./MailModal.vue?vue&type=template&id=336ba090&"
import script from "./MailModal.vue?vue&type=script&lang=js&"
export * from "./MailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports